module.exports = __webpack_public_path__ + "static/media/Logo_MP.6896b645.png";